import React from "react";
import { useParams } from "react-router-dom";
import { pageData, PageSlug } from "../../data/medicineEsthetiqueData";
import DynamicComponent from "../../components/DynamicComponent";
import SEO from "../../components/SEO";
import { pageSEOData } from "../../data/seoData";
import { createServiceSchema } from "../../utils/seo";

const DynamicPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const pageDataContent =
    pageData[slug as PageSlug] || pageData["acide-hyaluronique"];

  // Get SEO data for the slug, fallback to acide-hyaluronique if not found
  const seo = pageSEOData[slug as string] || pageSEOData["acide-hyaluronique"];

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        ogImage={seo.ogImage}
        structuredData={createServiceSchema(seo.title, seo.description)}
      />
      <DynamicComponent {...pageDataContent} />
    </>
  );
};

export default DynamicPage;
